<template>
  <div class="invoice-single">
    <iframe
      :src="iframeSrc"
      frameborder="0"
      width="100%"
      height="1000"
      v-if="iframeSrc"
      ref="frame"
      @load="iframeUrlChanged"
    ></iframe>
    <template v-else-if="!iframeSrc && !thanks">
      <b-row>
        <b-col
          :sm="12"
          class="d-flex flex-column justify-content-center unauthorized"
        >
          <p class="lead text-center">
            {{ $t('public.invoices.unauthorized') }}
          </p>
        </b-col>
      </b-row>
    </template>
    <template v-else>
      <b-row>
        <b-col
          :sm="12"
          class="d-flex flex-column justify-content-center unauthorized"
        >
          <p class="lead text-center">ESign Completed Successfully</p>
        </b-col>
      </b-row>
    </template>
  </div>
</template>
<script>
import moment from 'vue-moment'
export default {
  data() {
    return {
      iframeSrc: null,
      thanks: false
    }
  },
  mounted() {
    this.decodeURL()
  },
  computed: {
    redirectUrl() {
      return process.env.VUE_APP_DRIP_PORTAL_HOST
    }
  },
  methods: {
    decodeURL() {
      const regex = new RegExp(
        '^(?:(?:https?|ftp):\\/\\/)?(?:(?!(?:10|127)(?:\\.\\d{1,3}){3})(?!(?:169\\.254|192\\.168)(?:\\.\\d{1,3}){2})(?!172\\.(?:1[6-9]|2\\d|3[0-1])(?:\\.\\d{1,3}){2})(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}(?:\\.(?:[1-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\\.(?:[a-z\u00a1-\uffff]{2,})))(?::\\d{2,5})?(?:\\/\\S*)?$',
        'g'
      )
      const queryUrl = decodeURIComponent(this.$route.query.url)
      const paramUrl = decodeURIComponent(this.$route.params.url)
      this.iframeSrc = paramUrl.match(regex)
        ? paramUrl
        : queryUrl.match(regex)
        ? queryUrl
        : null
    },
    iframeUrlChanged() {
      try {
        console.log('try')
        console.log(this.$refs.frame.contentWindow.location.href)
        if (
          this.$refs.frame.contentWindow.location.href.indexOf(
            this.redirectUrl
          ) === 0
        ) {
          this.$mpTrack('Esign Completed')
          return this.esignSuccess()
        }
      } catch (e) {
        console.log('caught')
      }
    },
    esignSuccess() {
      this.iframeSrc = null
      this.thanks = true
      this.$notify({
        title: this.$t('notifications.esign.title'),
        text: this.$t('notifications.esign.text'),
        type: 'success'
      })
      if (moment() > this.$store.state.constants.lateTime) {
        this.$notify({
          title: this.$t('invoices.warnings.late.title'),
          text: this.$t('invoices.warnings.late.text'),
          type: 'warn',
          duration: -1
        })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.unauthorized {
  height: 75vh;
  .lead {
    font-size: 1.5rem;
    font-weight: 300;
  }
}
</style>
